

import { mapState } from 'vuex'

export default {
  props: { category: { type: [Object, String], required: true } },
  computed: mapState(['menuCategories', 'categories'])
}
